import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { clientSchema } from "./schema";
import { fetchClientData } from "./read";
import { useUpdateClient } from "../update/mutation";
import { useCreateClient } from "../create/mutation";
import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";

export const useClientForm = () => {
  const form = useForm({
    resolver: zodResolver(clientSchema),
    defaultValues: {},
  });

  const requiredFields = useMemo(
    () => getRequiredFields(clientSchema),
    [clientSchema],
  );

  const updateClient = useUpdateClient();
  const createClient = useCreateClient();

  const handleCreate = async (context) => {
    const item = context.values;
    await createClient.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateClient.mutateAsync({ clientId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchClientData({ clientId: id });
    return response;
  };

  return {
    form,
    requiredFields,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
